module.exports = __webpack_public_path__ + "img/bougies.b908be3.png";